const fallbackInitials = 'AI'

const wordInitials = (words: string[]) =>
  words.length >= 2 ? `${words[0][0]}${words[1][0]}` : words[0].slice(0, 2)

/**
 * Two-letter initials for each agent name, distinct within the list so the Agents pill can tell
 * agents apart without relying on colour.
 *
 * First letters of the first two words ("Chord Advisor" → "CA"). On a collision, the first two
 * letters of the first word ("Songwriting Collaborator" → "SO"). Failing that, a digit is appended
 * ("AG2"). An empty name reads "AI".
 */
export const getDistinctInitials = (names: string[]): string[] => {
  const taken = new Set<string>()
  return names.map(name => {
    const nameWords = name.trim().toUpperCase().split(/\s+/).filter(Boolean)
    const words = nameWords.length > 0 ? nameWords : [fallbackInitials]
    const preferred = wordInitials(words)
    const candidates = [preferred, words[0].slice(0, 2)]
    let initials = candidates.find(c => !taken.has(c))
    for (let n = 2; !initials; n++) {
      const candidate = `${preferred}${n}`
      initials = taken.has(candidate) ? undefined : candidate
    }
    taken.add(initials)
    return initials
  })
}
